






























































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

import Vue from 'vue'
import { Paginated, Params } from '@feathersjs/feathers'

import { lckServices } from '@/services/lck-api'
import { LckAclSet, LckGroup, LckUser } from '@/services/lck-api/definitions'

import Button from 'primevue/button'
import ConfirmDialog from 'primevue/confirmdialog'

import UserGroupForm from '@/components/admin/group/UserGroupForm.vue'
import { ROUTES_NAMES } from '@/router/paths'
import { GROUP_ROLE } from '@locokit/lck-glossary'

export default Vue.extend({
  name: 'CommonGroupListing',
  components: {
    'p-button': Vue.extend(Button),
    'p-confirm-dialog': Vue.extend(ConfirmDialog),
    'lck-usergroup-form': UserGroupForm,
  },
  props: {
    workspaceId: {
      type: String,
      required: false,
    },
    groupId: {
      type: String,
      required: false,
    },
    sidebarActive: {
      type: Boolean,
      required: false,
    },
  },
  data (): {
    aclSetSuggestions: { label: string; value: string }[];
    userSuggestions: { label: string; value: number }[];
    selectedGroup: LckGroup | null;
    groups: LckGroup[];
    submitting: boolean;
    loading: boolean;
    } {
    return {
      aclSetSuggestions: [],
      userSuggestions: [],
      selectedGroup: null,
      groups: [],
      submitting: false,
      loading: false,
    }
  },
  computed: {
    routeNameGroupDetail () {
      if (this.workspaceId) {
        return ROUTES_NAMES.WORKSPACE_ADMIN.GROUP_DETAIL
      } else {
        return ROUTES_NAMES.ADMIN.GROUP_DETAIL
      }
    },
    routeNameGroup () {
      if (this.workspaceId) {
        return ROUTES_NAMES.WORKSPACE_ADMIN.GROUP
      } else {
        return ROUTES_NAMES.ADMIN.GROUP
      }
    },
  },
  async mounted () {
    await this.fetchGroups()
  },
  methods: {
    /**
     * Hide the update form and reset the selected aclSet.
     */
    cancelEdit () {
      this.selectedGroup = null
    },
    /**
     * Set some default data for the new aclset and display the form.
     */
    async createGroup () {
      this.selectedGroup = new LckGroup()
      // Case for workspace/admin/group
      if (
        [ROUTES_NAMES.WORKSPACE_ADMIN.GROUP, ROUTES_NAMES.WORKSPACE_ADMIN.GROUP_DETAIL].includes(this.$route.name as string)
      ) {
        return await this.$router.push({
          name: ROUTES_NAMES.WORKSPACE_ADMIN.GROUP_ADD,
          params: {
            ...this.$route.params,
            groupId: '',
          },
        })
      }
      // Case for admin/group
      return await this.$router.push({
        name: ROUTES_NAMES.ADMIN.GROUP_ADD,
        params: {
          ...this.$route.params,
          groupId: '',
        },
      })
    },
    /**
     * Display an error toast whose the content is based on the error code.
     */
    displayToastOnError (error: Error & { code: number }) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('error.basic'),
        detail: this.$t('error.http.' + error.code),
        life: 5000,
      })
    },
    /**
     * Fetch more information about the aclset that we want to update
     * set some default data and display the form.
     */
    async fetchGroup (groupId: string) {
      try {
        this.selectedGroup = await lckServices.group.get(groupId, {
          query: {
            $eager: '[users, aclset.[workspace, chapter]]',
          },
        })
      } catch (error) {
        this.displayToastOnError(error as any)
      }
    },
    /**
     * Delete the group from database
     */
    async saveGroup (group: LckGroup) {
      this.submitting = true
      try {
        if (!group.id) {
          const response = await lckServices.group.create({
            name: group.name,
            aclset_id: group.aclset_id,
          }, {
            query: {
              $eager: '[aclset.[workspace, chapter]]',
            },
          })
          this.selectedGroup!.name = response.name
          this.selectedGroup!.aclset_id = response.aclset_id
          this.selectedGroup!.aclset = response.aclset
        } else {
          const response = await lckServices.group.patch(group.id, {
            name: group.name,
            aclset_id: group.aclset_id,
          }, {
            query: {
              $eager: '[aclset.[workspace, chapter]]',
            },
          })
          this.selectedGroup!.name = response.name
          this.selectedGroup!.aclset_id = response.aclset_id
          this.selectedGroup!.aclset = response.aclset
        }
        /**
         * Refresh the listing with the new group / updated group
         */
        this.fetchGroups()
      } catch (error) {
        this.displayToastOnError(error as any)
      }
      this.submitting = false
    },
    /**
     * Fetch the workspace's groups.
     */
    async fetchGroups () {
      this.loading = true
      try {
        const groupParams: Params = {
          query: {
            $limit: -1,
          },
        }
        /**
         * When we are on the workspaceAdmin.groups route
         */
        if (this.workspaceId) {
          groupParams.query!.$joinRelation = '[aclset.[workspace]]'
          groupParams.query!['aclset:workspace.id'] = this.workspaceId
        }
        const responseGroups = await lckServices.group.find(groupParams) as LckGroup[]
        this.groups = responseGroups
      } catch (error) {
        this.displayToastOnError(error as any)
      }
      this.loading = false
    },
    /**
     * Add a new user in a group
     */
    async addUserInGroup (userId: number, groupId: string, role: GROUP_ROLE) {
      this.submitting = true
      try {
        await lckServices.usergroup.create({
          user_id: userId,
          group_id: groupId,
          uhg_role: role,
        })
      } catch (error) {
        this.displayToastOnError(error as any)
      }
      await this.fetchGroup(this.groupId)
      this.submitting = false
    },
    /**
     * Edit the user in a group
     */
    async editUserInGroup (userId: number, groupId: string, role: GROUP_ROLE) {
      this.submitting = true
      try {
        await lckServices.usergroup.patch(
          `${userId},${groupId}`,
          { uhg_role: role },
        )
      } catch (error) {
        this.displayToastOnError(error as any)
      }
      this.fetchGroup(this.groupId)
      await this.fetchGroup(this.groupId)
      this.submitting = false
    },
    /**
     * Delete a user in a group
     */
    async deleteUserInGroup (userId: number, groupId: string) {
      this.submitting = true
      try {
        await lckServices.usergroup.remove(
          `${userId},${groupId}`,
        )
      } catch (error) {
        this.displayToastOnError(error as any)
      }
      await this.fetchGroup(this.groupId)
      this.submitting = false
    },
    async onSearchAclset ({ query }: { query: string }) {
      const aclsetParams: Params = {
        query: {
          label: {
            $ilike: `%${query}%`,
          },
        },
      }
      /**
       * When we are on the workspaceAdmin.groups route
       */
      if (this.workspaceId) {
        aclsetParams.query!.workspace_id = this.workspaceId
      }

      const aclSetsMatched = await lckServices.aclset.find(aclsetParams) as Paginated<LckAclSet>
      this.aclSetSuggestions = aclSetsMatched.data.map(d => ({
        label: d.label,
        value: d.id,
      }))
    },
    async onSearchUser ({ query }: { query: string }) {
      const usersMatched = await lckServices.user.find({
        query: {
          blocked: false,
          name: {
            $ilike: `%${query}%`,
          },
        },
      }) as Paginated<LckUser>
      this.userSuggestions = usersMatched.data.map(d => ({
        label: d.name,
        value: d.id,
      }))
    },
  },
  watch: {
    groupId: {
      handler (newValue) {
        if (!newValue) return
        this.fetchGroup(newValue)
      },
      immediate: true,
    },
  },
})
